<style>
  .content {
    min-height: calc(100% - (920px));
  }
</style>
<div class="download-report"><a href="https://mailchi.mp/f68678587486/booz17va2q" target="_blank">Click here</a> to download the 2025 Influencer Marketing Report </div>
<app-header></app-header>
<div class="content">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
<app-cookies-consent></app-cookies-consent>